/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface ActivitiesIdentifyGetIdentifyInfoRes {
  code: number;
  msg: string;
  data: Data;
  nonce: string;
}
export interface Data {
  /**
   * 实名认证截止时间
   */
  deadline: number;
  /**
   * 是否实名认证
   */
  b_identify: boolean;
}

const ActivitiesIdentifyGetIdentifyInfo = async (ctx?: GetServerSidePropsContext) => {
  const res = await http.post<ActivitiesIdentifyGetIdentifyInfoRes>(
    '/wemeet-tapi',
    '/v2/activities/identify/get-identify-info',
    {},
    ctx,
  );

  return res;
};

export default ActivitiesIdentifyGetIdentifyInfo;
